import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import { NotificationManager } from 'Components/Notifications';
import { sendVehicleRemoteCommand } from '../api/sendVehicleRemoteCommand';
import { addSentCommand } from '../remoteCommandsCache';
import { newClientRequestId, remoteCommandErrorKey } from '../remoteCommandsUtils';

const FAILED_ON_SEND = ['REJECTED', 'FAILED'];

/**
 * Sends a door command. One `clientRequestId` per call (one per confirmed
 * click), which the backend dedupes on. The returned row becomes the current
 * command and the head of the cached history; REJECTED / FAILED rows are
 * returned (not thrown), so they toast their error here, and rejected sends
 * toast a translated reason (CONFLICT / UNAUTHORIZED / generic).
 */
export const useSendVehicleRemoteCommand = () => {
	const queryClient = useQueryClient();
	const { messages } = useIntl();

	return useMutation({
		mutationFn: ({ unitId, command }) =>
			sendVehicleRemoteCommand({ unitId, command, clientRequestId: newClientRequestId() }),
		onSuccess: (row, { unitId }) => {
			if (!row) return;
			addSentCommand(queryClient, unitId, row);
			if (FAILED_ON_SEND.includes(row.status)) {
				NotificationManager.error(row.errorMessage || messages['oemDataModal_remote_failed']);
			}
		},
		onError: (error) => {
			NotificationManager.error(messages[remoteCommandErrorKey(error)]);
		},
	});
};
